export default "__VITE_ASSET__DqcQ$FbP__"